<template>
  <div
    class="border border-gray-200/75 rounded-lg p-1.5 flex items-center h-8 gap-x-px"
  >
    <div
      v-for="(marker, index) in props.markers"
      :key="index"
      :style="{
        ...(marker && {
          background: marker.color,
          opacity: marker.visible === false ? 0.15 : 1,
        }),
      }"
      class="w-1/128 h-full flex items-center"
    >
      <div
        v-if="marker?.shine"
        class="w-full h-4/5 brightness-[3]"
        :style="{
          ...(marker && {
            background: `linear-gradient(transparent, ${marker.color}, transparent)`,
          }),
        }"
      ></div>
    </div>
  </div>
</template>

<script setup lang="ts">
export interface MarkerLike {
  color: string
  shine: boolean
  visible?: boolean | null
}

const props = defineProps<{
  markers: ReadonlyArray<MarkerLike | null>
}>()
</script>
